import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import classes from "../../style/Style.module.css";
import LottieAnimation from "../../Components/Animation/LottieAnimation";
import { setSelectedPortfolioType } from "../../Store/UpdatedPortfolioData/userPortfolioSlice";
import { setUpdatedPortfolioData } from "../../Store/UpdatedPortfolioData/updatedPortfolioActions";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { setAccessToken } from "../../Store/Token/AuthTokenSlice";
import { selectRefreshToken, setRefreshToken } from "../../Store/Token/refreshTokenSlice";
import { setPanNumber } from "../../Store/panNumberSlice";
import {
  ROUTE_DEPENDED_PEOPLE,
  ROUTE_HOLD_INVESTMENT,
  ROUTE_INVESTMENT_PROFILE,
  Address_Verification,
  ROUTE_FATCA_CONFIRMATION,
  ROUTE_NSE_CONFIRMATION_WAITING,
  ROUTE_DXTER_SCANNING,
  ROUTE_NRI_TaxResidency,
  ROUTE_PORT_FOLIO,
  ROUTE_NRI_Address,
  Gender_Dob_Verification,
  ROUTE_FATCA_Failed,
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_BLANK_TEXT_SCREEN,
  ROUTE_RESIDENTIAL_STATUS,
  ROUTE_NOMINEE_DETAILS,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_PAN_VERIFICATION,
  ROUTE_UPLOAD_CANCELLED_CHEQUE,
  ROUTE_NRI_Pincode,
  ROUTE_EMAIL,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_CHECKBOXES,
  ROUTE_SIP_Confirmation_Link,
  ROUTE_KYC_PROCESS,
  ROUTE_KYC_NOT_DONE,
  ROUTE_ACCOUNT_TYPE,
  ROUTE_PLACEOF_BIRTH,
  ROUTE_NOMINEE_GUARDIAN,
  ROUTE_NOMINEE_VERIFICATION,
} from "../../Routes";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setLoginToken } from "../../Store/loginTokenSlice";
import { refreshTokenFunction } from "./Refreshtoken";

const DextersScanning = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const phoneNumber = useSelector(selectPhoneNumber);
  const token = useSelector((state) => state.loginToken.value);
  const refreshToken = useSelector(selectRefreshToken);
  const accessToken  = useSelector((state) => state.storedToken.accessToken);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (location.state?.tokens) {
      dispatch(setLoginToken(location.state.tokens));
      dispatch(setRefreshToken(location.state.tokens.refreshToken));
    }
  }, [location.state, dispatch]);

  useEffect(() => {
    // Check if accessToken exists; if not, fetch it. Skip if already present
    if (!accessToken) {
      callUserInfoApi(token);
    } else {
      callNextAPIs(accessToken); // If token exists, call further APIs
    }
  }, [token, accessToken]);


  const callUserInfoApi = async (token) => {
    const apiUrl = "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
    const requestBody = {
      otplessUserInfo: {
        otplessToken: token,
      },
    };

    try {
      setIsLoading(true);

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let response = await axios.post(apiUrl, requestBody, { headers });

      if (response.data.status) {
        const accessToken = response.data.data.accessToken;
        const refreshToken = response.data.data.refreshToken;

        dispatch(setAccessToken(accessToken));
        dispatch(setRefreshToken(refreshToken));

        callNextAPIs(accessToken);
      } else {
        console.error("Initial API response failed.");
        navigate(ROUTE_DXTER_SCANNING); // Navigate to scanning route
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsLoading(false);
    }
  };




  const callNextAPIs  = async (accessToken) => {

    const apiUrl = "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    };

    const customerBasicQuestionsBody = {
      dexterrCustomerBasicQuestions: {
        country_code: "+91",
        mobile_no: phoneNumber,
        request_type: "get",
      },
    };

      try {
        setIsLoading(true);

       

        // Initial API call
         let customerBasicQuestionsResponse  = await axios.post(apiUrl, customerBasicQuestionsBody, { headers });

        

         

          if (customerBasicQuestionsResponse.data.statusCode === 200) {
            const responseData = customerBasicQuestionsResponse.data.data;
            dispatch(setPanNumber(responseData.pan));

            // Navigation logic based on response data
            if (responseData.resident === "") {
              navigate(ROUTE_RESIDENTIAL_STATUS);
            } else if (responseData.investment_years === "") {
              navigate(ROUTE_HOLD_INVESTMENT);
            } else if (responseData.investment_profile === "") {
              navigate(ROUTE_INVESTMENT_PROFILE);
            } else if (responseData.financial_dependant === "") {
              navigate(ROUTE_DEPENDED_PEOPLE);
            } else if (responseData.temporary_drop_percentage_portfolio === "") {
              navigate(ROUTE_PORT_FOLIO);
            } else {
              const portfolioRequestBody = {
                dexterrPortfolio: {
                  pan: responseData.pan,
                  resident: responseData.resident,
                  investment_years: responseData.investment_years,
                  investment_profile: responseData.investment_profile,
                  temporary_drop_percentage_portfolio:
                    responseData.temporary_drop_percentage_portfolio,
                },
              };

              const portfolioResponse = await axios.post(
                apiUrl,
                portfolioRequestBody,
                { headers: { ...headers, Authorization: `Bearer ${accessToken}` } }
              );

              if (portfolioResponse.data.statusCode === 200) {
                const portfolioData = portfolioResponse.data.body;
                dispatch(setUpdatedPortfolioData(portfolioData));
                const portfolioTypeKey = Object.keys(portfolioData.portfolio_type)[0];
                dispatch(setSelectedPortfolioType(portfolioTypeKey));
                navigate(ROUTE_UPDATED_PORT_FOLIO_SCREEN, {
                  state: { Resident: responseData.resident },
                });
                // navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE)
              } else {
                console.error("Portfolio API response failed.");
                // Stay on the current screen; do not navigate
              }
            }
          } else {
            console.error("Customer Basic Questions API response failed.");
            // Stay on the current screen; do not navigate
          }
        
      } catch (error) {
        console.error("An error occurred:", error);
        // Handle network or other errors
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div className={classes.DextersScanning_Main_Container}>
        <div className={classes.LottiePlayer_Container}>
          <LottieAnimation />
        </div>
      </div>
    );
  };

  export default DextersScanning;
